@if (navigationCategories$ | async; as categories) {
<ul class="category-level{{ subCategoriesDepth() }}" [ngClass]="{ 'dropdown-menu': subCategoriesDepth() === 1 }">
  @for (subcategory of categories; track subcategory) {
  <li class="main-navigation-level{{ subCategoriesDepth() }}-item" [ngClass]="{ open: isOpened(subcategory.uniqueId) }">
    <a
      [routerLink]="subcategory.url"
      [ngStyle]="{
        width: !(subCategoriesDepth() < mainNavigationMaxSubCategoriesDepth && subcategory.hasChildren) ? '100%' : ''
      }"
      >{{ subcategory.name }}</a
    >
    @if (subCategoriesDepth() < mainNavigationMaxSubCategoriesDepth && subcategory.hasChildren) {
    <a
      class="dropdown-toggle"
      [ngClass]="{ 'd-none': view() === 'full' }"
      (click)="toggleOpen(subcategory.uniqueId)"
      (keydown.enter)="toggleOpen(subcategory.uniqueId)"
      role="button"
      [attr.aria-label]="
        isOpened(subcategory.uniqueId)
          ? ('header.navigation.collapse_category.aria_label' | translate : { '0': subcategory.name })
          : ('header.navigation.expand_category.aria_label' | translate : { '0': subcategory.name })
      "
      tabindex="0"
    >
      @if (isOpened(subcategory.uniqueId)) {
      <fa-icon [icon]="['fas', 'minus']" />
      } @else {
      <fa-icon [icon]="['fas', 'plus']" />
      }
    </a>
    <ish-sub-category-navigation
      [categoryUniqueId]="subcategory.uniqueId"
      [subCategoriesDepth]="subCategoriesDepth() + 1"
    />
    }
  </li>
  }
</ul>
}
